import React from 'react';
import { useOutletContext } from 'react-router-dom';
import mensHealth from '../../../../images/MyAccountSubscriptions/mens_health.png';
import womensHealth from '../../../../images/MyAccountSubscriptions/womens_health.jpg';
import generalMedicine from '../../../../images/MyAccountSubscriptions/general_medicine.png';
import SubscriptionRootCategoryCard from './SubscriptionRootCategoryCard';
import CarePlusWeightLossUpsellCard from './CarePlusWeightLossUpsellCard';
import CarePlusPlanCard from '../CarePlus/CarePlusPlanCard/CarePlusPlanCard';

type Props = {
	categoriesSuggestions: Record<string, { root_title: string; id: number; title: string; mention: string; shortcut: string; link: string }[]>;
};

const SubscriptionCategoriesSuggestions: React.FC<Props> = ({ categoriesSuggestions }) => {
	const { asideBarData } = useOutletContext<any>();

	// Map root_code to specific image
	const getImageByRootCodeCategory = (rootCodeCategory: string) => {
		if (rootCodeCategory.includes('women')) return womensHealth;
		if (rootCodeCategory.includes('men')) return mensHealth;
		return generalMedicine;
	};

	return (
		<div id="subscription-categories-suggestions" className="flex flex-col items-start gap-4 font-roboto new-subscription-desktop">
			{asideBarData?.enableCarePlusCard && (asideBarData?.carePlusSubscriptionHashId
				? <CarePlusPlanCard subscriptionHashID={asideBarData.carePlusSubscriptionHashId} />
				: <CarePlusWeightLossUpsellCard />)}
			{Object.entries(categoriesSuggestions).map(([rootCodeCategory, categories]) => (
				<SubscriptionRootCategoryCard key={rootCodeCategory} rootCodeCategory={rootCodeCategory} rootTitle={categories[0].root_title} categories={categories} image={getImageByRootCodeCategory(rootCodeCategory)} />
			))}
		</div>
	);
};

export default SubscriptionCategoriesSuggestions;
